import React from 'react';

const PurchasedCoursesSection = ({ language = 'traditional', onCourseClick }) => {
  const getText = (textObj) => {
    return textObj[language] || textObj.traditional;
  };

  const purchasedCourses = [
    {
      id: 'grammar_book',
      icon: '📚',
      title: {
        traditional: '語法書',
        simplified: '语法书',
        english: 'Grammar Book'
      },
      subtitle: {
        traditional: '系統性語法學習',
        simplified: '系统性语法学习',
        english: 'Systematic Grammar Learning'
      },
      progress: 85,
      color: 'from-blue-500 to-cyan-600'
    },
    {
      id: 'ielts_study',
      icon: '🎯',
      title: {
        traditional: 'IELTS 學習',
        simplified: 'IELTS 学习',
        english: 'IELTS Study'
      },
      subtitle: {
        traditional: '國際英語測試',
        simplified: '国际英语测试',
        english: 'International English Test'
      },
      progress: 65,
      color: 'from-green-500 to-emerald-600'
    },
    {
      id: 'toefl_study',
      icon: '📝',
      title: {
        traditional: 'TOEFL 學習',
        simplified: 'TOEFL 学习',
        english: 'TOEFL Study'
      },
      subtitle: {
        traditional: '托福考試準備',
        simplified: '托福考试准备',
        english: 'TOEFL Exam Prep'
      },
      progress: 45,
      color: 'from-purple-500 to-violet-600'
    },
    {
      id: 'my_school_book',
      icon: '🏫',
      title: {
        traditional: '我的學校課本',
        simplified: '我的学校课本',
        english: 'My School Book'
      },
      subtitle: {
        traditional: '個人化學習記錄',
        simplified: '个性化学习记录',
        english: 'Personalized Records'
      },
      progress: 75,
      color: 'from-orange-500 to-red-600'
    }
  ];

  return (
    <div className="px-6 mb-6">
      {/* Section Title */}
      <h2 className="text-lg font-semibold mb-4 text-white">
        {language === 'traditional' ? '已買課程' :
         language === 'simplified' ? '已买课程' :
         'Purchased Courses'}
      </h2>

      {/* Courses Grid */}
      <div className="grid grid-cols-2 gap-4">
        {purchasedCourses.map((course) => (
          <button
            key={course.id}
            onClick={() => onCourseClick?.(course.id)}
            className={`p-4 rounded-xl bg-gradient-to-r ${course.color} text-center hover:scale-105 transition-transform duration-200 cursor-pointer`}
          >
            <div className="text-3xl mb-2">{course.icon}</div>
            <h3 className="font-semibold text-white mb-1">
              {getText(course.title)}
            </h3>
            <p className="text-white/80 text-xs mb-3">
              {getText(course.subtitle)}
            </p>
            
            {/* Progress Bar */}
            <div className="w-full bg-white/20 rounded-full h-2 mb-2">
              <div 
                className="bg-white h-2 rounded-full transition-all duration-300"
                style={{ width: `${course.progress}%` }}
              ></div>
            </div>
            
            {/* Progress Text */}
            <div className="text-white/90 text-xs">
              {course.progress}% {language === 'traditional' ? '完成' :
                                language === 'simplified' ? '完成' :
                                'Complete'}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default PurchasedCoursesSection;
